/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPDISINVESTMENTTYPE } from './IAPDISINVESTMENTTYPE';
import {
    IAPDISINVESTMENTTYPEFromJSON,
    IAPDISINVESTMENTTYPEFromJSONTyped,
    IAPDISINVESTMENTTYPEToJSON,
} from './IAPDISINVESTMENTTYPE';
import type { IAPONCEOFFINVESTMENTSOURCEOFMONEY } from './IAPONCEOFFINVESTMENTSOURCEOFMONEY';
import {
    IAPONCEOFFINVESTMENTSOURCEOFMONEYFromJSON,
    IAPONCEOFFINVESTMENTSOURCEOFMONEYFromJSONTyped,
    IAPONCEOFFINVESTMENTSOURCEOFMONEYToJSON,
} from './IAPONCEOFFINVESTMENTSOURCEOFMONEY';
import type { IAPPRODUCTCODE } from './IAPPRODUCTCODE';
import {
    IAPPRODUCTCODEFromJSON,
    IAPPRODUCTCODEFromJSONTyped,
    IAPPRODUCTCODEToJSON,
} from './IAPPRODUCTCODE';
import type { IAPPRODUCTCONFIGURATIONCODE } from './IAPPRODUCTCONFIGURATIONCODE';
import {
    IAPPRODUCTCONFIGURATIONCODEFromJSON,
    IAPPRODUCTCONFIGURATIONCODEFromJSONTyped,
    IAPPRODUCTCONFIGURATIONCODEToJSON,
} from './IAPPRODUCTCONFIGURATIONCODE';
import type { ProposalSummaryEffectiveAnnualCost } from './ProposalSummaryEffectiveAnnualCost';
import {
    ProposalSummaryEffectiveAnnualCostFromJSON,
    ProposalSummaryEffectiveAnnualCostFromJSONTyped,
    ProposalSummaryEffectiveAnnualCostToJSON,
} from './ProposalSummaryEffectiveAnnualCost';
import type { ProposalSummaryFeesDetails } from './ProposalSummaryFeesDetails';
import {
    ProposalSummaryFeesDetailsFromJSON,
    ProposalSummaryFeesDetailsFromJSONTyped,
    ProposalSummaryFeesDetailsToJSON,
} from './ProposalSummaryFeesDetails';
import type { ProposalSummaryFundDetails } from './ProposalSummaryFundDetails';
import {
    ProposalSummaryFundDetailsFromJSON,
    ProposalSummaryFundDetailsFromJSONTyped,
    ProposalSummaryFundDetailsToJSON,
} from './ProposalSummaryFundDetails';
import type { ProposalSummaryIntermediaryDetails } from './ProposalSummaryIntermediaryDetails';
import {
    ProposalSummaryIntermediaryDetailsFromJSON,
    ProposalSummaryIntermediaryDetailsFromJSONTyped,
    ProposalSummaryIntermediaryDetailsToJSON,
} from './ProposalSummaryIntermediaryDetails';
import type { ProposalSummaryOnceOffInvestment } from './ProposalSummaryOnceOffInvestment';
import {
    ProposalSummaryOnceOffInvestmentFromJSON,
    ProposalSummaryOnceOffInvestmentFromJSONTyped,
    ProposalSummaryOnceOffInvestmentToJSON,
} from './ProposalSummaryOnceOffInvestment';
import type { ProposalSummaryRecurringContributions } from './ProposalSummaryRecurringContributions';
import {
    ProposalSummaryRecurringContributionsFromJSON,
    ProposalSummaryRecurringContributionsFromJSONTyped,
    ProposalSummaryRecurringContributionsToJSON,
} from './ProposalSummaryRecurringContributions';
import type { ProposalSummaryRegularWithdrawals } from './ProposalSummaryRegularWithdrawals';
import {
    ProposalSummaryRegularWithdrawalsFromJSON,
    ProposalSummaryRegularWithdrawalsFromJSONTyped,
    ProposalSummaryRegularWithdrawalsToJSON,
} from './ProposalSummaryRegularWithdrawals';

/**
 * 
 * @export
 * @interface ProposalSummaryInvestmentDetails
 */
export interface ProposalSummaryInvestmentDetails {
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryInvestmentDetails
     */
    productId?: number;
    /**
     * 
     * @type {IAPPRODUCTCODE}
     * @memberof ProposalSummaryInvestmentDetails
     */
    productCode?: IAPPRODUCTCODE;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryInvestmentDetails
     */
    productCodeName: string;
    /**
     * 
     * @type {IAPPRODUCTCONFIGURATIONCODE}
     * @memberof ProposalSummaryInvestmentDetails
     */
    productConfigurationCode?: IAPPRODUCTCONFIGURATIONCODE;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryInvestmentDetails
     */
    productConfigurationCodeName: string;
    /**
     * 
     * @type {ProposalSummaryOnceOffInvestment}
     * @memberof ProposalSummaryInvestmentDetails
     */
    onceOffInvestment?: ProposalSummaryOnceOffInvestment;
    /**
     * 
     * @type {ProposalSummaryRecurringContributions}
     * @memberof ProposalSummaryInvestmentDetails
     */
    recurringContributions?: ProposalSummaryRecurringContributions;
    /**
     * 
     * @type {ProposalSummaryRegularWithdrawals}
     * @memberof ProposalSummaryInvestmentDetails
     */
    regularWithdrawals?: ProposalSummaryRegularWithdrawals;
    /**
     * 
     * @type {ProposalSummaryEffectiveAnnualCost}
     * @memberof ProposalSummaryInvestmentDetails
     */
    effectiveAnnualCost?: ProposalSummaryEffectiveAnnualCost;
    /**
     * 
     * @type {ProposalSummaryFeesDetails}
     * @memberof ProposalSummaryInvestmentDetails
     */
    feesDetails?: ProposalSummaryFeesDetails;
    /**
     * 
     * @type {Array<ProposalSummaryIntermediaryDetails>}
     * @memberof ProposalSummaryInvestmentDetails
     */
    intermediaryDetails?: Array<ProposalSummaryIntermediaryDetails>;
    /**
     * 
     * @type {ProposalSummaryFundDetails}
     * @memberof ProposalSummaryInvestmentDetails
     */
    fundDetails?: ProposalSummaryFundDetails;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalSummaryInvestmentDetails
     */
    isSupportedLivingAnnuityProduct: boolean;
    /**
     * 
     * @type {IAPONCEOFFINVESTMENTSOURCEOFMONEY}
     * @memberof ProposalSummaryInvestmentDetails
     */
    onceOffSourceOfMoneyId?: IAPONCEOFFINVESTMENTSOURCEOFMONEY;
    /**
     * 
     * @type {IAPDISINVESTMENTTYPE}
     * @memberof ProposalSummaryInvestmentDetails
     */
    feeDisinvestmentTypeId?: IAPDISINVESTMENTTYPE;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalSummaryInvestmentDetails
     */
    hasLumpSum?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalSummaryInvestmentDetails
     */
    hasTFSATransfer?: boolean;
}

/**
 * Check if a given object implements the ProposalSummaryInvestmentDetails interface.
 */
export function instanceOfProposalSummaryInvestmentDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productCodeName" in value;
    isInstance = isInstance && "productConfigurationCodeName" in value;
    isInstance = isInstance && "isSupportedLivingAnnuityProduct" in value;

    return isInstance;
}

export function ProposalSummaryInvestmentDetailsFromJSON(json: any): ProposalSummaryInvestmentDetails {
    return ProposalSummaryInvestmentDetailsFromJSONTyped(json, false);
}

export function ProposalSummaryInvestmentDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryInvestmentDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productId': !exists(json, 'ProductId') ? undefined : json['ProductId'],
        'productCode': !exists(json, 'ProductCode') ? undefined : IAPPRODUCTCODEFromJSON(json['ProductCode']),
        'productCodeName': json['ProductCodeName'],
        'productConfigurationCode': !exists(json, 'ProductConfigurationCode') ? undefined : IAPPRODUCTCONFIGURATIONCODEFromJSON(json['ProductConfigurationCode']),
        'productConfigurationCodeName': json['ProductConfigurationCodeName'],
        'onceOffInvestment': !exists(json, 'OnceOffInvestment') ? undefined : ProposalSummaryOnceOffInvestmentFromJSON(json['OnceOffInvestment']),
        'recurringContributions': !exists(json, 'RecurringContributions') ? undefined : ProposalSummaryRecurringContributionsFromJSON(json['RecurringContributions']),
        'regularWithdrawals': !exists(json, 'RegularWithdrawals') ? undefined : ProposalSummaryRegularWithdrawalsFromJSON(json['RegularWithdrawals']),
        'effectiveAnnualCost': !exists(json, 'EffectiveAnnualCost') ? undefined : ProposalSummaryEffectiveAnnualCostFromJSON(json['EffectiveAnnualCost']),
        'feesDetails': !exists(json, 'FeesDetails') ? undefined : ProposalSummaryFeesDetailsFromJSON(json['FeesDetails']),
        'intermediaryDetails': !exists(json, 'IntermediaryDetails') ? undefined : ((json['IntermediaryDetails'] as Array<any>).map(ProposalSummaryIntermediaryDetailsFromJSON)),
        'fundDetails': !exists(json, 'FundDetails') ? undefined : ProposalSummaryFundDetailsFromJSON(json['FundDetails']),
        'isSupportedLivingAnnuityProduct': json['IsSupportedLivingAnnuityProduct'],
        'onceOffSourceOfMoneyId': !exists(json, 'OnceOffSourceOfMoneyId') ? undefined : IAPONCEOFFINVESTMENTSOURCEOFMONEYFromJSON(json['OnceOffSourceOfMoneyId']),
        'feeDisinvestmentTypeId': !exists(json, 'FeeDisinvestmentTypeId') ? undefined : IAPDISINVESTMENTTYPEFromJSON(json['FeeDisinvestmentTypeId']),
        'hasLumpSum': !exists(json, 'HasLumpSum') ? undefined : json['HasLumpSum'],
        'hasTFSATransfer': !exists(json, 'HasTFSATransfer') ? undefined : json['HasTFSATransfer'],
    };
}

export function ProposalSummaryInvestmentDetailsToJSON(value?: ProposalSummaryInvestmentDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProductId': value.productId,
        'ProductCode': IAPPRODUCTCODEToJSON(value.productCode),
        'ProductCodeName': value.productCodeName,
        'ProductConfigurationCode': IAPPRODUCTCONFIGURATIONCODEToJSON(value.productConfigurationCode),
        'ProductConfigurationCodeName': value.productConfigurationCodeName,
        'OnceOffInvestment': ProposalSummaryOnceOffInvestmentToJSON(value.onceOffInvestment),
        'RecurringContributions': ProposalSummaryRecurringContributionsToJSON(value.recurringContributions),
        'RegularWithdrawals': ProposalSummaryRegularWithdrawalsToJSON(value.regularWithdrawals),
        'EffectiveAnnualCost': ProposalSummaryEffectiveAnnualCostToJSON(value.effectiveAnnualCost),
        'FeesDetails': ProposalSummaryFeesDetailsToJSON(value.feesDetails),
        'IntermediaryDetails': value.intermediaryDetails === undefined ? undefined : ((value.intermediaryDetails as Array<any>).map(ProposalSummaryIntermediaryDetailsToJSON)),
        'FundDetails': ProposalSummaryFundDetailsToJSON(value.fundDetails),
        'IsSupportedLivingAnnuityProduct': value.isSupportedLivingAnnuityProduct,
        'OnceOffSourceOfMoneyId': IAPONCEOFFINVESTMENTSOURCEOFMONEYToJSON(value.onceOffSourceOfMoneyId),
        'FeeDisinvestmentTypeId': IAPDISINVESTMENTTYPEToJSON(value.feeDisinvestmentTypeId),
        'HasLumpSum': value.hasLumpSum,
        'HasTFSATransfer': value.hasTFSATransfer,
    };
}

